class BonusGameData extends SlotGame.src.store.BonusGameData {
    public isFirstSpinStart: boolean = false;
    public isRestore: boolean = false;

    public onSpinGameRequest() {
        super.onSpinGameRequest();

        if (!this.isFirstSpinStart) this.isFirstSpinStart = true;
    }

    public reset() {
        super.reset();

        this.isFirstSpinStart = false;
    }
}

export { BonusGameData };

SlotGame.src.store.BonusGameData = BonusGameData;




